import React from "react";
import axios from "axios";
import moment from "moment";
import StudentsIndexlinks from "./indexLinks";

export default class StudentsCompetenceprofiles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            openCompetenceprofiles: [],
            openEndterms: [],
            cpCourses: {}
        };
    }

    getResults = () => {
        axios
            .all([axios.get("/v1/students/" + this.props.params.itemID + "/"), axios.get("/v1/users/" + this.props.params.itemID + "/competenceprofiles/")])
            .then(
                axios.spread((student, cpData) => {
                    this.setState({
                        loaded: true,
                        ...student.data,
                        competenceProfiles: cpData.data
                    });
                })
            )
            .catch((error) => {
                console.log(error);
            });
    };

    toggleCompetenceprofiles = (uuid) => {
        let openCompetenceprofiles = this.state.openCompetenceprofiles;
        let cpCourses = this.state.cpCourses;

        var i = openCompetenceprofiles.indexOf(uuid);
        if (i !== -1) {
            openCompetenceprofiles.splice(i, 1);
        } else {
            openCompetenceprofiles.push(uuid);

            // Check if we have the events already for this competence profile
            if (!cpCourses[uuid]) {
                // No results yet, get these
                axios
                    .get(`/v1/users/${this.props.params.itemID}/courses/?competence_profile=${uuid}&ordering=events__start_datetime`)
                    .then((response) => {
                        this.setState({
                            cpCourses: {
                                ...cpCourses,
                                [uuid]: response.data.results
                            }
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
        this.setState({
            openCompetenceprofiles
        });
    };

    toggleEndterms = (uuid) => {
        let checkArray = this.state.openEndterms;

        var i = checkArray.indexOf(uuid);
        if (i !== -1) {
            checkArray.splice(i, 1);
        } else {
            checkArray.push(uuid);
        }
        this.setState({
            openEndterms: checkArray
        });
    };

    componentDidMount() {
        this.getResults();

        if (this.props.params.cpID) {
            this.toggleCompetenceprofiles(this.props.params.cpID);
        }
    }

    render() {
        let resultHTML = <h2>Ophalen van gegevens...</h2>;
        let resultRows = [];
        let shownResults = [];

        if (this.state.loaded) {
            if (this.state.competenceProfiles.results) {
                this.state.competenceProfiles.results.forEach((cp) => {
                    // Competenceprofiles
                    let cpResult = (cpResult = (
                        <span className="text-danger">
                            <i className="fa fa-times"></i> Niet behaald
                        </span>
                    ));

                    cp.end_terms.forEach((et) => {
                        if (!cp.latest_progress) {
                            cpResult = (
                                <span>
                                    <i className="fa fa-ellipsis-h"></i> Nog bezig...
                                </span>
                            );
                        }
                    });

                    let expirationDate = "-";
                    if (cp.achieved) {
                        cpResult = (
                            <span className="text-success">
                                <i className="fa fa-check"></i> Behaald
                            </span>
                        );

                        if (cp.expiration_date !== null) {
                            expirationDate = moment(cp.expiration_date).format("DD-MM-YYYY");
                        } else {
                            expirationDate = "N.v.t.";
                        }
                    }

                    if (cp.courses.length > 0) {
                        resultRows.push(
                            <tr
                                key={cp.uuid}
                                onClick={(e) => {
                                    this.toggleCompetenceprofiles(cp.uuid);
                                }}
                            >
                                <td>
                                    <strong>
                                        {cp.name} {cp.is_active ? "" : " (inactief)"}
                                    </strong>
                                    {cp.description ? (
                                        <span className="lighter">
                                            <br />
                                            {cp.description}
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </td>
                                <td>{expirationDate}</td>
                                <td>{cpResult}</td>
                            </tr>
                        );
                    }

                    expirationDate = "-";
                    if (this.state.openCompetenceprofiles.includes(cp.uuid)) {
                        // Endterms
                        cp.end_terms.forEach((et) => {
                            let result = <span>Geen voortgang</span>;
                            expirationDate = "-";

                            if (et.latest_progress && et.latest_progress.achieved) {
                                result = (
                                    <span className="text-success">
                                        <i className="fa fa-check"></i> Behaald
                                    </span>
                                );
                            } else {
                                result = (
                                    <span>
                                        <i className="fa fa-ellipsis-h"></i> Nog bezig...
                                    </span>
                                );
                            }

                            let className = "fa fa-angle-right";
                            if (this.state.openEndterms.includes(cp.uuid + et.uuid)) {
                                className = "fa fa-angle-down";
                            }

                            if (et.latest_progress && et.latest_progress.achieved) {
                                expirationDate = "N.v.t.";

                                if (et.latest_progress.expiration_date !== null) {
                                    expirationDate = moment(et.latest_progress.expiration_date).format("DD-MM-YYYY");
                                }
                            }

                            resultRows.push(
                                <tr
                                    key={cp.uuid + et.uuid}
                                    onClick={(e) => {
                                        this.toggleEndterms(cp.uuid + et.uuid);
                                    }}
                                    className="jumpin"
                                >
                                    <td>
                                        <i className={className}></i>Eindterm: {et.name}
                                    </td>
                                    <td>{expirationDate}</td>
                                    <td>{result}</td>
                                </tr>
                            );

                            // Check open competences to show
                            if (this.state.openEndterms.includes(cp.uuid + et.uuid)) {
                                et.competences.forEach((comp) => {
                                    let result = <span>Geen voortgang</span>;
                                    expirationDate = "-";

                                    if (comp.latest_progress && comp.latest_progress.achieved) {
                                        result = (
                                            <span className="text-success">
                                                <i className="fa fa-check"></i> Behaald
                                            </span>
                                        );
                                    } else {
                                        result = (
                                            <span>
                                                <i className="fa fa-ellipsis-h"></i> Nog bezig...
                                            </span>
                                        );
                                    }

                                    if (comp.latest_progress && comp.latest_progress.achieved) {
                                        expirationDate = "N.v.t.";

                                        if (comp.latest_progress.expiration_date !== null) {
                                            expirationDate = moment(comp.latest_progress.expiration_date).format("DD-MM-YYYY");
                                        }
                                    }

                                    resultRows.push(
                                        <tr key={cp.uuid + et.uuid + comp.uuid} className="jumpin-2">
                                            <td>Competentie: {comp.name}</td>
                                            <td>{expirationDate}</td>
                                            <td>{result}</td>
                                        </tr>
                                    );
                                });
                            }
                        });

                        // Check any knowledge exam results
                        if (this.state.cpCourses[cp.uuid]) {
                            this.state.cpCourses[cp.uuid].forEach((course) => {
                                course.events.forEach((event) => {
                                    if (event.user_score !== null) {
                                        event.user_score.forEach((result) => {
                                            let shownKey = cp.uuid + event.uuid + result.measurement.uuid;

                                            if (!shownResults.includes(shownKey)) {
                                                resultRows.push(
                                                    <tr key={shownKey} className="jumpin">
                                                        <td>
                                                            <i className="fa fa-info"></i>
                                                            {result.measurement.name}
                                                        </td>
                                                        <td></td>
                                                        <td>{result.score.toFixed(1)}</td>
                                                    </tr>
                                                );
                                                shownResults.push(shownKey);
                                            }
                                        });
                                    }
                                });
                            });
                        }
                    }
                });

                if (resultRows.length > 0) {
                    resultHTML = (
                        <table className="table table-hover table-clickable mt-3">
                            <thead>
                                <tr>
                                    <th>Competentieprofiel</th>
                                    <th width="140">Geldig tot</th>
                                    <th width="140">Status</th>
                                </tr>
                            </thead>
                            <tbody>{resultRows}</tbody>
                        </table>
                    );
                } else {
                    // We have 0 results
                    resultHTML = <h2>Er zijn nog geen gegevens rondom competentieprofielen voor deze cursist.</h2>;
                }
            }
        }

        return (
            <div>
                <StudentsIndexlinks
                    title={this.state.full_name}
                    nibhv_number={this.state.nibhv_number}
                    studentUUID={this.props.params.itemID}
                    buttons={[{ title: "Cursist bewerken", link: "/students/edit/" + this.props.params.itemID, classname: "btn btn-primary" }]}
                />

                {resultHTML}
            </div>
        );
    }
}
